import React from 'react';
import { JcCommonProps, JcSize, JcUtils } from '../utils/JcUtils';

export interface JcLiveIndicatorProps extends JcCommonProps {
  /** Box size, matching the {@link JcIcon} scale. Defaults to SMALL. */
  readonly size?: JcSize;
  /** Accessible name. Defaults to "Live". */
  readonly ariaLabel?: string;
}

/**
 * A pulsing status dot for live/in-progress states. Fills the same square as a
 * {@link JcIcon} at the same size; colour comes from `--jc-live-indicator-color`
 * (defaults to `currentColor`).
 */
export const JcLiveIndicator: React.FunctionComponent<JcLiveIndicatorProps> = (props) => {
  const size = props.size ?? JcSize.SMALL;
  const commonProps = JcUtils.commonProps(props, [
    "jc-live-indicator",
    size !== JcSize.NONE && ("jc-live-indicator-size-" + size),
  ]);

  return (
    <span {...commonProps} role="status" aria-label={props.ariaLabel ?? "Live"}>
      <span className="jc-live-indicator-dot" />
    </span>
  );
};
